/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade200,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade401,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade500,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationResponse,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade.ts";
import { classModuleDisciplineConfigViewModelSchema } from "../classModuleDisciplineConfigViewModelSchema.ts";

export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParamsSchema =
  z.object({
    classModuleId: z.coerce.number().int(),
    disciplineId: z.coerce.number().int(),
  }) as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade200Schema =
  z.lazy(
    () => classModuleDisciplineConfigViewModelSchema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade401Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade500Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade500>;

export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationResponseSchema =
  z.lazy(
    () =>
      patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGrade200Schema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInGradeMutationResponse>;
